import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo } from "react";

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/DataTableContainer';

import { useDispatch, useSelector } from "react-redux";
import { fetchCustomersData } from "../../store/customers/actions";

const Customers = props => {
    const dispatch = useDispatch();

    const { data, loading, error } = useSelector(state => state.Customers);

    useEffect(() => {
        dispatch(fetchCustomersData());
      }, [dispatch]);

    const columns = useMemo(
        () => [
          {
            header: "Image",
            accessorKey: "profile_pic",
            enableColumnFilter: false,
            cell: ({ row }) => (
              <img
                src={row.original.profile_pic || "assets/images/no-image.png"}
                alt="Profile"
                style={{ width: 40, height: 40, borderRadius: "50%" }}
              />
            )
          },
          {
            header: 'Name',
            accessorKey: 'name',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Email',
            accessorKey: 'email',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Phone',
            accessorKey: 'phone',
            enableColumnFilter: false,
            enableSorting: true,
          },
        ],
        []
      );

    const totalRecords = data?.data?.length ?? 0;
    
    const transformedData = data?.data?.map(item => {
        return {
            profile_pic: item.profile_pic || "assets/images/no-image.png",
            name: item.user_name || "N/A",
            email: item.email || "N/A",
            phone: item.phone_code + " " + item.mobno || "N/A",
        };
    });

    console.log(transformedData);
    
    document.title = "Cusomters | Moeen";
    return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Home" breadcrumbItem="Customers" />
        {loading ? (
        <Skeleton count={10} height={40} />
        ) : (
        <TableContainer
          columns={columns}
          data={transformedData || []}
          isGlobalFilter={true}
          isPagination={true}
          SearchPlaceholder={`Looking for something? ${totalRecords} results loaded.`}
          pagination="pagination"
          paginationWrapper='dataTables_paginate paging_simple_numbers'
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      )}
      </div>
    </div>
  );
};

Customers.propTypes = {
  t: PropTypes.any
};

export default Customers;